var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-z-[11000] tw-opacity-80 tw-top-0 tw-left-0 tw-fixed tw-h-full tw-w-full tw-bg-whitesmoke"},[_c('div',{staticClass:"tw-flex tw-justify-center tw-relative tw-text-base tw-w-auto tw-h-12 tw-top-[40%]"},[_c('img',{attrs:{"alt":"loader","src":require('@/assets/images/loader.gif')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }